<template>
  <AuthLayout>
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Reset your password</h1>
      <p class="text-sm text-gray-400 mt-1">Enter your email and we'll send you a reset link</p>
    </div>

    <!-- Success state -->
    <div v-if="sent" class="mt-8">
      <div class="p-4 rounded-lg bg-green-50 border border-green-100">
        <div class="flex items-start gap-2">
          <svg class="w-5 h-5 text-green-500 mt-0.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          <div>
            <p class="text-sm font-medium text-green-700">Check your email</p>
            <p class="text-sm text-green-600 mt-0.5">If an account exists for <strong>{{ email }}</strong>, we've sent a password reset link.</p>
          </div>
        </div>
      </div>
      <router-link to="/login" class="mt-6 w-full h-11 rounded-lg bg-[var(--color-primary)] text-white text-sm font-medium hover:bg-[var(--color-primary-hover)] transition-colors flex items-center justify-center">
        Back to Sign In
      </router-link>
    </div>

    <!-- Form -->
    <form v-else @submit.prevent="handleReset" class="mt-8">
      <div class="space-y-5">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1.5">Email address</label>
          <input v-model="email" type="email" required autocomplete="email" placeholder="you@company.com" />
        </div>
      </div>

      <button type="submit" :disabled="loading || !email" class="mt-6 w-full h-11 rounded-lg bg-[var(--color-primary)] text-white text-sm font-medium hover:bg-[var(--color-primary-hover)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        {{ loading ? 'Sending...' : 'Send Reset Link' }}
      </button>

      <p class="text-center text-sm text-gray-400 mt-4">
        <router-link to="/login" class="text-[var(--color-primary)] hover:underline">Back to Sign In</router-link>
      </p>
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from './AuthLayout.vue'
import api from '../../services/api.js'
import { notifyError } from '../../services/notifications.js'

export default {
  name: 'ForgotPassword',
  components: { AuthLayout },

  data() {
    return { email: '', loading: false, sent: false }
  },

  methods: {
    async handleReset() {
      this.loading = true
      try {
        await api.post('/auth/password-reset', { email: this.email })
        this.sent = true
      } catch (err) {
        // Always show success to prevent email enumeration
        this.sent = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
